export const USER_PERMISSIONS = {
  LIST_PROVIDER: "LIST_PROVIDER",
  LIST_COMPANY: "LIST_COMPANY",
  UPLOAD: "UPLOAD",
};
